import React from 'react';
import { ArrowRightOutlined, ClusterOutlined, LinkOutlined } from '@ant-design/icons';

const diseaseData = [
    // 首页疾病谱数据按用户新提供表格更新，替换旧数据源
    { rank: 1, name: 'Ear-related disorders', code: 'Phe0001', sampleCount: 13494, percent: 44.55, url: 'http://gdcdb.net' },
    { rank: 2, name: 'Neurological disorders', code: 'Phe0002', sampleCount: 5488, percent: 18.12 },
    { rank: 3, name: 'Cardiovascular system disorders', code: 'Phe0010', sampleCount: 2458, percent: 8.12 },
    { rank: 4, name: 'Orofacial deformities', code: 'Phe0009', sampleCount: 2432, percent: 8.03 },
    { rank: 5, name: 'Genetic related tumors', code: 'Phe0006', sampleCount: 2032, percent: 6.71 },
    { rank: 6, name: 'Hematological and immunological disorders', code: 'Phe0007', sampleCount: 1239, percent: 4.09 },
    { rank: 7, name: 'Ocular disorders', code: 'Phe0011', sampleCount: 783, percent: 2.59 },
    { rank: 8, name: 'Dermatological disorders', code: 'Phe0004', sampleCount: 736, percent: 2.43 },
    { rank: 9, name: 'Musculoskeletal disorders', code: 'Phe0005', sampleCount: 621, percent: 2.05 },
    { rank: 10, name: 'Genitourinary system disorders', code: 'Phe0003', sampleCount: 340, percent: 1.12 },
    { rank: 11, name: 'Endocrine system disorders', code: 'Phe0014', sampleCount: 295, percent: 0.98 },
    { rank: 12, name: 'Metabolic & homeostatic disorders', code: 'Phe0008', sampleCount: 221, percent: 0.73 },
    { rank: 13, name: 'Gastrointestinal disorders', code: 'Phe0013', sampleCount: 59, percent: 0.20 },
    { rank: 14, name: 'Ultra-rare disorders', code: 'Phe0016', sampleCount: 49, percent: 0.16 },
    { rank: 15, name: 'Respiratory system disorders', code: 'Phe0015', sampleCount: 21, percent: 0.07 },
    { rank: 16, name: 'Fetal intrauterine developmental disorders', code: 'Phe0012', sampleCount: 19, percent: 0.06 },
];

const BarChart = () => {
    const maxCount = Math.max(...diseaseData.map(item => item.sampleCount));
    const donutColors = [
        '#18b7c9', '#087c96', '#c89a3c', '#0b8eaa',
        '#1b9c84', '#6aa6b8', '#a7cfd8', '#d9e8ed'
    ];
    const donutGradient = diseaseData.reduce((segments, item, index) => {
        const start = segments.offset;
        const end = start + item.percent;
        const color = donutColors[index % donutColors.length];

        return {
            offset: end,
            value: `${segments.value}${color} ${start}% ${end}%, `
        };
    }, { offset: 0, value: '' }).value + '#edf4f6 99.98% 100%';

    const handleOpen = (url) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <section className="disease-rank-panel">
            <div className="disease-rank-header">
                <div className="disease-rank-title">
                    <span className="disease-rank-title-icon">
                        <ClusterOutlined />
                    </span>
                    <div>
                        <h2>Disease Spectrum of Probands</h2>
                    </div>
                </div>
            </div>

            <div className="disease-rank-body">
                <div className="disease-rank-list">
                    {diseaseData.map(item => {
                        const width = `${Math.max((item.sampleCount / maxCount) * 100, 3)}%`;
                        const clickable = Boolean(item.url);

                        return (
                            <button
                                key={item.code}
                                type="button"
                                className={`disease-rank-row ${clickable ? 'is-clickable' : ''}`}
                                onClick={() => handleOpen(item.url)}
                                disabled={!clickable}
                                aria-label={clickable ? `Open ${item.name}` : item.name}
                            >
                                {/* 疾病排行保留原始数据字段，仅调整为更清晰的数据面板展示 */}
                                <span className="disease-rank-index">{item.rank}</span>
                                <span className="disease-rank-main">
                                    <span className="disease-rank-name">
                                        {item.name}
                                        {clickable && <LinkOutlined />}
                                    </span>
                                    <span className="disease-rank-track">
                                        <i style={{ width }} />
                                    </span>
                                </span>
                                <span className="disease-rank-count">{item.sampleCount.toLocaleString()}</span>
                                {clickable && <ArrowRightOutlined className="disease-rank-arrow" />}
                            </button>
                        );
                    })}
                </div>
                <aside className="disease-rank-visual" aria-label="Disease category distribution summary">
                    <div className="disease-donut-wrap">
                        <div className="disease-donut" style={{ background: `conic-gradient(${donutGradient})` }}>
                            <div className="disease-donut-center">
                                <strong>{diseaseData.length}</strong>
                                <span>categories</span>
                            </div>
                        </div>
                    </div>
                    <div className="disease-donut-legend">
                        {diseaseData.map((item, index) => (
                            <div className="disease-donut-legend-row" key={item.code}>
                                {/* 饼图图例使用同一份 diseaseData，避免新增或改动数据字段 */}
                                <i style={{ background: donutColors[index % donutColors.length] }} />
                                <span>{item.name}</span>
                                <strong>{item.percent.toFixed(2)}%</strong>
                            </div>
                        ))}
                    </div>
                </aside>
            </div>
        </section>
    );
};

export default BarChart;
